export const profile = {
  title: 'Profile',
  oldPassword: 'Old password',
  newPassword: 'New password',
  repeatNewPassword: 'Repeat new password',
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email',
  authenticator: 'Authenticator',
  role: 'Role',
  fieldRequired: 'This field is required',
  passwordRules: {
    minLength: 'At least {min} characters',
    uppercase: 'At least one uppercase letter (A-Z)',
    lowercase: 'At least one lowercase letter (a-z)',
    number: 'At least one number (0-9)',
    specialCharacter: 'At least one special character ({characters})',
  },
  passwordStrength: {
    title: 'Password strength',
    subTitle: 'Check fulfilled requirements',
    power: {
      weak: 'Weak',
      medium: 'Medium',
      strong: 'Strong',
    },
  },
  updateSuccess: 'Profile has been successfully updated',
  passwordUpdateSuccess: 'Password has been successfully updated',
  add2FAModalTitle: 'Add 2FA method',
  insertPassword: 'Enter password',
  insertAuthenticatorCode: 'Enter code from authenticator app',
  updatedDefault2FAMethod: 'Default 2FA method has been updated',
  confirmDelete2FAModalTitle: 'Confirm 2FA method deletion',
  successDeleted2FAModal: '2FA method has been successfully deleted',
  successAdd2FAMethod: '2FA method has been successfully added',
  confirmChangePasswordTitle: 'Confirm password change',
}
